<template>
    <div class="landing-page">
        <Header class="header" ref="header" @logout="logout" @emitLogin='activeLoginSignup' @emitSignup='activeLoginSignup' :loginStatus="loginStatus" @openUpgrade="openUpgrade"/>
        <div class="content">
            <div class="inner-content">
                <h3>EXPO-BLOCKS</h3>
                <div v-show="loginStatus">
                  
                    <p>Or you can be a blocker，to create your unique blocks here, and show in every device!</p>
                    <button class="submit" @click="$refs.header.goPanel()">{{customer.type=="normal" ? "Be a blocker":"My blocks"}}</button>
                </div>
                <div v-show="!loginStatus">
                    <p>You can create your unique exhibitions here, and show in every device! No longer limited by distance, epidemics,  space...<br>Let us get together here at any time!</p>
                    <button class="submit" @click="activeLoginSignup">Let’s party !</button>
                </div>
            </div>
        </div>
        <!-- <div style="z-index:999999999999;   cursor:pointer;color:#fff;position:absolute;top:100px;left:10px;background-color:#000;border:1px solid #fff;" @click="state++;">UI STATE SWITCH</div> -->
        <DialogFrame class='dialog-frame' ref='dialogLoginSignup' :needClose='true' :needButton='false' @signupInit="signupInit">
            <!-- LOGIN AS USER / BLOCKER -->
            <div class="dialog-cotent" slot='dialog-content' v-show="state===FLOW_STATE.LOGIN">
                <h6>Welcome to Expo-Blocks</h6>
                <div class="input-box">
                    <input type="text" v-model="form.account" name='formEmail' placeholder="Email or account ID" autocomplete="off">
                    <span class='fs14' :class="{active: hint&&(!form.account&&!form.email)}">{{currentType===ACCOUNT_TYPE.USER?`Email is required`:`Wrong mailbox`}}</span>
                    <input type="password" v-model="form.password" name='formName' placeholder="Password" autocomplete="off">
                    <span class='fs14' :class="{active: hint&&(!form.password)}">{{currentType===ACCOUNT_TYPE.USER?`Password is required`:`Wrong password`}}</span>
                </div>
                <span class="not-verified" :class="{active: hint&&(this.form.account&&this.form.password)}">You are not eligible for this block. Please check your email for ticket information.</span>
                <div class="forgot" @click="state=5">Forgot password?</div>
                <div class="button-box">
                    <button @click="actionLogin">Login</button>
                    <button @click="changeToSignUp">{{currentType===ACCOUNT_TYPE.USER?`Signup`:`Signup as blocker`}}</button>
                    <button @click="ghostVisit" class="last" >Visit Without an Account</button>
                </div>
                <p style="color:#B1AEAE;font-size:12px;">Some amazing features are limited to members only.</p>
            </div>
            <!-- VISITOR -->
            <div class="dialog-cotent" slot='dialog-content' v-show="state===FLOW_STATE.VISITOR">
                <div class="type-switch">
                    <div @click='currentType=ACCOUNT_TYPE.USER' :class='{active:currentType===ACCOUNT_TYPE.USER}' class="viewer">Viwer</div>
                    <div @click='currentType=ACCOUNT_TYPE.BLOCKER' :class='{active:currentType===ACCOUNT_TYPE.BLOCKER}' class="blocker">Blocker</div>
                </div>
                <h6>What’s your nickname?</h6>
                <div class="input-box">
                    <input type="text" v-model="form.visitorName" name='visitorName' placeholder="Nickname" autocomplete="off">
                </div>
                <div class="button-box">
                    <button class='mtop24 mbottom24' @click="actionLogin">Get stated</button>
                    <button class='only-text' @click="" style="color:#4454ff">< Back to sign up</button>
                </div>
            </div>
            <!-- SIGNUP -->
            <div class="dialog-cotent" slot='dialog-content' v-show="state===FLOW_STATE.SIGNUP_EMAIL">
                <h6>Sign up to Expo-blocks</h6>
                <div class="input-box">
                    <span style='color:#333'>Email</span>
                    <input style='margin: 4px 0' type="text" v-model="form.signupEmail" name='signupEmail' placeholder="example@gmail.com" autocomplete="off">
                </div>
                <div class="forgot" style='text-align:center' @click="state=FLOW_STATE.LOGIN;form.signupEmail=''">Already have an account?</div>
                <div class="button-box">
                    <button @click="sendMail">Next</button>
                </div>
            </div>
            <!-- SIGNUP VERFIY -->
            <div class="dialog-cotent" slot='dialog-content' v-show="state===FLOW_STATE.SIGNUP_VERIFY">
                <h6>Verify your email address</h6>
                <img src="@/assets/img/icon/verify-email.svg" alt="">
                <span class='gray mtop24 mbottom24'>We’ve sent you an email to {{this.form.email}}. The code will be expired within 10 mins.</span>
                <div class="input-box">
                    <span style='color:#333'>Verification code</span>
                    <input style='margin: 4px 0' type="text" v-model="form.signupCode" name='signupCode' placeholder="Enter code" autocomplete="off">
                </div>
                <!-- <div class="forgot" style='text-align:center'>Already have an account?</div> -->
                <span v-if="resndProgress==0" style="color:#FB4A93;text-align:center;margin: 9px 0 12px;font-size:12px">Your verification code has expired.</span>
                <div class="button-box">
                    <button @click="verifiedMail">Get Started</button>
                </div>
                <span class="gray mtop24">Didn’t received email? <span style="color:#4454ff" class="btn" @click="resend">Resend email. ({{resndProgress}}s)</span></span>
            </div>
            <!-- SIGNUP DETAILS -->
            <div class="dialog-cotent" slot='dialog-content' v-show="state===FLOW_STATE.SIGNUP_DETAILS">
                <h6>Sign up to Expo-blocks</h6>
                <div class="input-box">
                    <span class='fs12' style='color:#333'>Account</span>
                    <input style='margin: 4px 0' type="text" v-model="form.signupAccount" name='signupAccount' placeholder="Account ID" autocomplete="off">
                    <span class='fs12' style='color:#333'>User Name</span>
                    <input style='margin: 4px 0' type="text" v-model="form.signupName" name='signupName' placeholder="Nickname" autocomplete="off">
                    <span class='fs12' style='color:#333'>Password</span>
                    <input style='margin: 4px 0' type="password" v-model="form.signupPassword" name='signupPassword' placeholder="8-12 characters" autocomplete="off">
                    <span class='fs12' style='color:#333'>Confirm Password</span>
                    <input style='margin: 4px 0' type="password" v-model="form.signupPassword2" name='signupPassword2' placeholder="Re-enter password" autocomplete="off">
                </div>
                <div class="button-box" style="margin:14px 0 6px 0">
                    <button @click="createAccount">Create Account</button>
                </div>
                <span class="gray" style="text-align:left">By clicking Create account, you agree to the Expo-blocks Privacy policy and Cookie Policy.</span></span>
            </div>
            <!-- FORGOT SEND MAIL -->
            <div class="dialog-cotent" slot='dialog-content' v-show="state===FLOW_STATE.FORGOT_SEND_EMAIL">
                <h6>Forgot password</h6>
                <div class="input-box">
                    <span class='fs12' style='color:#333'>Email</span>
                    <input style='margin: 4px 0' type="email" v-model="form.forgotEmail" name='forgotEmail' placeholder="Enter email" autocomplete="off">
                </div>
                <div class="button-box" style="margin:14px 0 6px 0">
                    <button @click="sendResetPassMail">Next</button>
                    <button @click="state=1">< Back</button>
                </div>
            </div>
            <!-- FORGOT VERIFY and WAIT-->
            <div class="dialog-cotent" slot='dialog-content' v-show="state===FLOW_STATE.FORGOT_WAIT_EMAIL" name>
                <h6>Forgot password</h6>
                <img src="@/assets/img/icon/verify-email.svg" alt="">
                <span class="gray mtop24 mbottom24">Please check <span style="color:#333">{{this.form.forgotEmail}}</span> to change your password.</span>
                <div class="button-box" style="margin:14px 0 6px 0">
                    <button @click="state=1">Log in</button>
                </div>
            </div>
            <!-- CHANGE PASSWORD -->
            <div class="dialog-cotent" slot='dialog-content' v-show="state===FLOW_STATE.CHANGE_PASSWORD" name>
                <h6>Change Password</h6>
                <div class="input-box">
                    <span class='fs12' style='color:#333'>New Password</span>
                    <input style='margin: 4px 0' type="password" v-model="form.newPassword" name='newPassword' placeholder="8-12 characters" autocomplete="off">
                    <span class='fs12' style='color:#333'>Confirm Password</span>
                    <input style='margin: 4px 0' type="password" v-model="form.newPassword2" name='newPassword2' placeholder="Re-enter password" autocomplete="off">
                </div>
                <div class="button-box" style="margin:14px 0 6px 0">
                    <button @click="">Change Password</button>
                </div>
            </div>
            <!-- COOKIE POLICY -->
            <div class="dialog-cotent" slot='dialog-content' v-show="state===FLOW_STATE.COOKIE_POLICY" name>
                <h6>Cookie Policy</h6>
                <span class="gray fs14 overflowyAuto" style="line-height:20px;text-align:left;">Cookies Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer's hard drive.Our website uses these “cookies” to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service.</span>
                <div class="button-box" style="margin:14px 0 6px 0">
                    <button class='last' @click="state=1">< Back</button>
                </div>
            </div>
            <!-- PRIVACY POLICY -->
            <div class="dialog-cotent" slot='dialog-content' v-show="state===FLOW_STATE.PRIVACY_POLICY" name>
                <h6>Privacy Policy</h6>
                <span class="gray fs14 overflowyAuto" style="line-height:20px;text-align:left;">Cookies Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer's hard drive.Our website uses these “cookies” to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service.files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer's hard drive.Our website uses these “cookies” to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Servicefiles with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer's hard drive.Our website uses these “cookies” to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Servicefiles with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer's hard drive.Our website uses these “cookies” to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Servicefiles with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer's hard drive.Our website uses these “cookies” to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service</span>
                <div class="button-box" style="margin:14px 0 6px 0">
                    <button class='last' @click="state=1">< Back</button>
                </div>
            </div>
        </DialogFrame>
        <Upgrade ref="upgrade" :upgradeStep="upgradeStep" @updrageNextStep="updrageNextStep" @updragePreStep="updragePreStep" @closeUpdrade="closeUpdrade" v-if="vendorUpgrade"/>
        <Footer class="login-footer" />
    </div>
</template>
<script>
import Header from "@/components/Header2.vue";
import Footer from "@/components/Footer.vue";
import DialogFrame from "@/components/DialogFrame.vue";
import Upgrade from "@/components/Vendor/Upgrade.vue";
import { mapActions,mapGetters } from 'vuex';
import { login,sendVerified,verifiedMail,resendVerified,signupByVerified,sendResetPassMail,getUserData,upgradeAccount,getVenderProfile,blockchainAccount,blockchainLogin} from "@/api";

export default {
    name:'LandingPage',
    data() {
        return{ 
            state: 1,
            currentType: 0,
            hint: false,
            hintTimer: null,
            form: {
                account: '',
                email: '',
                password: '',
                signupAccount: '',
                signupEmail: '',
                signupName: '',
                signupCode: '',
                signupPassword: '',
                signupPassword2: '',
                forgotEmail: '',
                newPassword: '',
                newPassword2: '',
                visitorName: '',
                signupToken:''
            },
            FLOW_STATE: Object.freeze({
                NONE: 0,
                LOGIN: 1,
                SIGNUP_EMAIL: 2,
                SIGNUP_VERIFY: 3,
                SIGNUP_DETAILS: 4,
                FORGOT_SEND_EMAIL: 5,
                FORGOT_WAIT_EMAIL: 6,
                CHANGE_PASSWORD: 7,
                COOKIE_POLICY: 8,
                PRIVACY_POLICY: 9,
                VISITOR: 10,
            }),
            ACCOUNT_TYPE: Object.freeze({
                USER: 0,
                BLOCKER: 1,
            }),
            upgradeStep:0,
            vendorUpgrade:false,
            resndProgress:30,
            downloadTimer:null,
            loginStatus:false
        }
    },
    mounted(){
        this.$store.dispatch('loader/show');
        window.state = this.state;
        if(localStorage.hasOwnProperty('token')){
            // if(localStorage.type="seller")
            //     this.getVenderProfileInfo();
            // else
            this.checkInfo();
        }
        this.$store.dispatch('loader/hide');
    },
    computed:{
        ...mapGetters(['customer']),
    },
    methods:{
        ...mapActions(['setLogin','setVendor']),
        async checkInfo(){
            let vm = this;
            let loginRes;
            await getUserData().then(res=>{
                loginRes = res.data.data;
            }).catch(err=>{
                console.log(err);
                this.toggleHint(1500);
            });
            await this.setLogin(loginRes)
            .then(auth=>{
                if(loginRes.type=='seller')vm.getVenderProfileInfo();
                this.signupInit();
                this.loginStatus = true;
            })
            .catch(err=>{
            })
        },
        activeLoginSignup(){
            this.$refs.dialogLoginSignup.active();
        },
        async actionLogin(){
            let vm = this;
            if((!this.form.email&&!this.form.account) || !this.form.password){
                this.toggleHint(0);
            }
            let loginRes;
            await login(this.form)
            .then(res=>{
                loginRes = res.data.data;
/////////////////////////////////////////////////////////////////////////////////////                
                let _loginRes = res.data.data;
                _loginRes = JSON.stringify(_loginRes);
                console.log(_loginRes);
                //blockchainLogin(_loginRes);
                window.parent.postMessage("reload", "*");
                // 解析JSON字符串
                var jsonObj = JSON.parse(_loginRes);
                // 從JSON對象中獲取token的值
                var token = jsonObj.token;
                document.cookie = `token=${token}; domain=.dlll.nccu.edu.tw; path=/; SameSite=None; Secure`;
/////////////////////////////////////////////////////////////////////////////////////                
            }).catch(err=>{
                this.toggleHint(0);
                vm.$message({
                    showClose: true,
                    message: `Account or Password got wrong!`,
                    type: 'error',
                    duration: 1500,
                });
                loginRes = 0;
            });
            if(!loginRes)return;
            await this.setLogin(loginRes)
            .then(auth=>{
                this.signupInit();
                this.loginStatus = true;
                this.$refs.dialogLoginSignup.active();
                if(auth==='normal'){
                    console.log('登入成功');
                }
            })
            .catch(err=>{
            })
        },
        toggleHint(ms){
            this.hint = true;
            if(!ms) return;
            if(this.hintTimer){ 
                clearTimeout(this.hintTimer);
            }
            this.hintTimer = setTimeout(()=>{this.hint = false;}, ms);
        },
        async updrageNextStep(param){
            let vm = this;
            if(this.upgradeStep==0&&param.email.trim()!=this.customer.email.trim()){
                this.$refs.upgrade.sendMail();
            }
            else{
                if(this.upgradeStep==2){
                    let obj = {
                        email: param.email,
                        emailToken:param.emailToken, // optional 如果 email 跟 user.email 一樣就不用重複驗證，如果不是則要取得驗證的 token
                        avatarUrl: "", // optional
                        introduction: param.introduction,
                        companyName: param.companyName,
                        phone: param.companyName,
                        address: param.address,
                        link: "", // optional
                    }
                    let res = await upgradeAccount(obj).catch(function (error) {
                        if (error.response) {
                            vm.$message({
                                showClose: true,
                                message: `${error.response.data.message}`,
                                type: 'error',
                                duration: 1500,
                            });
                        }
                    });
                    if(res.status==201){
                        vm.$message({
                            showClose: true,
                            message: `Upgrade Successfully!`,
                            type: 'success',
                            duration: 1500,
                            onClose:()=>{
                                // window.open(location.protocol+'//'+window.location.host+'/landing');
                                window.location.reload();
                            }
                        });
                    }
                    vm.closeUpdrade();
                }else{
                    this.upgradeStep += 1;
                }
            }
        },
        updragePreStep(){
            this.upgradeStep -= this.upgradeStep>0?1:0;
        },
        closeUpdrade(){
            this.upgradeStep = 0;
            this.vendorUpgrade = false;
        },
        signupInit(){
            this.state = 1;
            this.form = {
                account: '',
                email: '',
                password: '',
                signupAccount: '',
                signupEmail: '',
                signupName: '',
                signupCode: '',
                signupPassword: '',
                signupPassword2: '',
                forgotEmail: '',
                newPassword: '',
                newPassword2: '',
                visitorName: '',
                signupToken:''
            }
        },
        async sendMail(){
            let vm = this;
            if(this.form.signupEmail=='')return;
            let param = {
                email:this.form.signupEmail
            }
            let res = await sendVerified(param).catch(function (error) {
                  if (error.response) {
                    vm.$message({
                        showClose: true,
                        message: `${error.response.data.message}`,
                        type: 'error',
                        duration: 1500,
                    });
                  }
            });
            if(res.data.status==200){
                this.state = 3;
                this.setCountdown();
            }
        },
        async verifiedMail(){
            let vm = this;
            if(this.form.signupCode=='')return;
            let param = {
                email:this.form.signupEmail,
                verifiedCode:this.form.signupCode
            }
            let res = await verifiedMail(param).catch(function (error) {
                  if (error.response) {
                    console.log(error.response)
                    vm.$message({
                        showClose: true,
                        message: `${error.response.data.message}`,
                        type: 'error',
                        duration: 1500,
                    });
                  }
            });
            if(res.data.status==200){
                clearInterval(vm.downloadTimer);
                this.form.signupToken = res.data.data.token
                this.state = 4;
            }
        },
        setCountdown(){
            let vm = this;
            let timeleft = 30;
            vm.downloadTimer = setInterval(function(){
                if(timeleft <= 0){
                    clearInterval(vm.downloadTimer);
                }
                vm.resndProgress = timeleft;
                timeleft -= 1;
            }, 1000);
        },
        async resend(){
            let param = {
                email:this.form.signupEmail
            }
            let res = await resendVerified(param).catch(function (error) {
                  if (error.response) {
                    console.log(error.response)
                    vm.$message({
                        showClose: true,
                        message: `${error.response.data.message}`,
                        type: 'error',
                        duration: 1500,
                    });
                  }
            });
            if(res.data.status==200){
                this.setCountdown();
            }
        },
        async createAccount(){
            let vm = this;
            if(!this.form.signupName||this.form.signupPassword!=this.form.signupPassword2||!this.form.signupName)return;
            let param = {
                nickname: this.form.signupName,
                account: this.form.signupAccount,
                password: this.form.signupPassword,
                token: this.form.signupToken
            }
            let res = await signupByVerified(param).then(auth=>{
                    vm.$message({
                        showClose: true,
                        message: `註冊成功，請重新登入`,
                        duration: 1500,
                        onClose:()=>{
                            vm.signupInit();
                            vm.$refs.dialogLoginSignup.active();
                        }
                    });
/////////////////////////////////////////////////////////////////////////////////////                    
                    let param_blockchain0 = param;
                    let param_blockchain = JSON.stringify(param_blockchain0);
                    console.log(param_blockchain);
                    blockchainAccount(param_blockchain);
/////////////////////////////////////////////////////////////////////////////////////                    
                }).catch(function (error) {
                  if (error.response) {
                    vm.$message({
                        showClose: true,
                        message: `${error.response.data.message}`,
                        type: 'error',
                        duration: 1500,
                    });
                  }
            });
        },
        async sendResetPassMail(){
            let vm = this;
            let param = {
                email:this.form.forgotEmail
            }
            let res = await sendResetPassMail(param).catch(function (error) {
                  if (error.response) {
                    console.log(error.response)
                    vm.$message({
                        showClose: true,
                        message: `${error.response.data.message}`,
                        type: 'error',
                        duration: 1500,
                    });
                  }
            });
            if(res.data.status==200){
                this.state = 6;
            }
        },
        openSignup(){
            if(this.customer._id){
                this.$router.push('/')
            }else{
                this.activeLoginSignup();
                this.state = 2;
            }
        },  
        openUpgrade(){
            let vm = this;
            if(this.customer.type=="normal"){
                this.vendorUpgrade = true;
            }else if(this.customer.type=="seller"){
                this.$message({
                    showClose: true,
                    message: "You are already blocker!",
                    type: 'warning',
                    duration: 1500,
                });
            }else{
                this.$message({
                    showClose: true,
                    message: "Please sign up viwer account first!",
                    type: 'warning',
                    duration: 1500,
                    onClose:()=>{
                        vm.openSignup();
                    }
                });
            }
        },
        changeToSignUp(){
            this.state = 2;
            if(this.currentType==1){
                this.$message({
                    showClose: true,
                    message: "Need to upgrade after sign up viwer account!",
                    type: 'warning',
                    duration: 1500,
                });
            }
        },
        async getVenderProfileInfo(){
            let vm = this
            let res = await getVenderProfile().catch(function (error) {
                  if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    return error.response.status
                  }
            });
            console.log(res)
            this.setVendor(res.data.data)
        },
        ghostVisit(){
            this.$router.push('/');
            localStorage.setItem('token', 'visitor');
            localStorage.setItem("type", 'visitor');
            this.$message({
                showClose: true,
                message: `Hi! You've entered our exhibitions with visitor identity!`,
                type: 'success',
                duration: 3500,
                onClose: ()=>{
                    this.$router.push('/');
                }
            });
        },
        logout(){
            this.loginStatus = false;
        }
    },
    components:{Header,Footer,DialogFrame,Upgrade},
}
</script>
<style lang="scss" scoped>
body, html{
        overflow-x: hidden;
}
*{
    transition: .2s all ease-in-out;
}
.dialog-cotent {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 95%;
    width: 300px;
    margin: 30px 30px;
    .type-switch{
        display: flex;
        justify-content: space-between;
        margin-bottom: 36px;
        font-size: 14px;
        div{
            width: 145px;
            height: 23px;
            cursor: pointer;
            &.active{
                position: relative;
                transition: .3s;
                &:after{
                    content: "";
                    width: 100%;
                    position: absolute;
                    top: 100%;
                    left: 0;
                    border-bottom: 1px solid #4454ff;
                }
            }
        }
    }
    .input-box{
        display: flex;
        flex-direction: column;
        input{
            height: 36px;
            padding:8px 14px;
            letter-spacing: 1.2px;
            border: 1px solid #333;
            &::placeholder{
                font-size: 13px;
                color: #b1aeae;
            }
            &:nth-child(2){
                margin-top: 14px
            }
        }
        span{
            margin: 6px 0px;
            align-self: flex-start;
            color: transparent;
            user-select: none;
            color: transparent;
            // font-size: 14px;
            &.active{
                color: #fb4a93;
            }
        }
    }
    .forgot{
        text-align: right;
        margin: 0px 0 15px 0;
        font-size: 14px;
        color: #4454ff;
        cursor: pointer;
    }
    .not-verified{
        color: #fb4a93;
        text-align: left;
        font-size: 14px;
        margin-bottom: 6px;
        height: 0;
        overflow: hidden;
        &.active{
            height: auto;
        }
    }
    h6{
        font-size: 14px;
        margin: 18px 0 27px 0;
    }
    .button-box{
        display: flex;
        flex-direction: column;
        button{
            height: 35px;
            border: none;
            border-radius: 5px;
            background-color: #4454ff;
            font-size: 14px;
            color: #fff;
            box-shadow: 2px 5px 10px 1px rgba($color: #000000, $alpha: 0.15);
            &:nth-child(2), &.last{
                background-color: #f7f7f7;
                color: #333;
                margin: 10px 0 0 0;
            }
            &.last{
                color: #4454ff;
                margin-bottom: 13%;
            }
            &.only-text{
                border: none;
                background-color: transparent;
            }
            &:hover{
                filter: drop-shadow(0px 5px 4px rgba(0, 0, 0, 0.4));
            }
        }
    }
    .or-block{
        display: flex;
        justify-content:space-between;
        align-items:center;
        font-size: 14px;
        margin: 36px 0 14px 0;
        div{
            width: 100px;
            height: 1.5px;
            background-color: #efefef;
        }
    }
    .without-account{
        margin: 22px 0 14px 0;
        font-size: 14px;
        cursor: pointer;
        color: #4454ff;
    }
    .features{
        font-size: 12px;
        color: #b1aeae;
    }
    .gray{
        font-size: 14px;
        color: #b1aeae;
    }
}
.mtop24{
    margin-top: 24px;
}
.mbottom24{
    margin-bottom: 24px;
}
.fs12{
    font-size: 12px;
}
.fs14{
    font-size: 14px;
}
.overflowyAuto{
    max-height: 350px;
    overflow-y: auto;
}
.header{
    position: absolute;
    top: 0;
    left: 0;
    opacity: .9;
}
.login-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    opacity: .7;
    background-color: #e1e7f6;
}
.landing-page{
    width: 100%;
    height: 100vh;
    .content{
        width: 100%;
        height: 100%;
        padding: 170px 0;
        display: flex;
        flex-direction: column;
        align-items:center;
        // background-image: url('~@/assets/img/shadertoy.png');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        overflow: auto;
        @media screen and (max-width: 600px){
            padding: 100px 0;
        }
        .inner-content{
            width: 470px;
            text-align: left;
            @media screen and (max-width: 600px){
                width: 260px;
            }
            img{
                display: block;
                //width: 90%;
                width:300px;
            }
            h3{
                font-weight: bold;
                font-size: 40px;
                margin: 15px 0;
            }
            p{
                font-size:14px;
                color: #333;
                line-height:28px;
            }
            button{
                line-height: 2.4;
                width: 150px;
                text-align: left;
                padding: 0 14px;
                border-radius: 7px;
                font-size: 14px;
                box-shadow: 1.97px 5.83px 19.7px 0px rgba(0, 0, 0, 0.15);
                position:relative;
                &:before{
                    content:'>';
                    position:absolute;
                    width:5px;
                    right:20px;
                    top:50%;
                    transform: translateY(-50%);
                }
            }
        }
    }
}
</style>